export const facetFilterQms = (locationId) => {
    const nestedFilters = `${[`"locations.id:${locationId}"`, `"locations.fg_queue:true"`]}`;
    const objFilter = { nestedFilters };

    return objFilter;
};